/*
 * @prettier
 * @copyright (c) 2019 - present, HGC-AB
 * @licence This source code is licensed under the MIT license described and found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react'
import { withPrefix } from 'gatsby'

// material-ui
import { AppBar, Toolbar, IconButton, Typography, Tabs, withStyles  } from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'

// custom components
import SEO from '../SEO/SEO'
import { TabLink } from '../Links/Link'

const styles = theme => ({
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  }
})

/**
 * Header component for the site
 * @param {Object} props - component properties
 * @param {String} props.title - the title of the article
 * @param {String} props.description - the description of the article (excerpt)
 * @param {Object} props.location - representing where the app is from a router perspective
 * @returns {*}
 * @constructor
 */
function SiteHeader({ classes, title, siteMeta, description, location, navigate }) {
  const { defaultTitle, navigationLinks } = siteMeta
  // create a new array with nav uris
  const navigationURIs = navigationLinks.map(nav => withPrefix(nav.uri))
  // check whether current location path exists in navigation uri's array
  const isPathInNavigation = navigationURIs.find(value => {
    return location.pathname.startsWith(value)
  })
  // if not exist, provide a falsy value to the tabs navigator
  const tabsValue = isPathInNavigation ? isPathInNavigation : false

  return (
    <AppBar position="fixed">
      <SEO title={title} description={description} siteMeta={siteMeta} />
      <Toolbar>
        <IconButton
          onClick={() => navigate('/')}
          className={classes.menuButton}
          edge="start"
          color="inherit"
          aria-label="menu"
        >
          <MenuIcon />
        </IconButton>
        <Typography className={classes.title} variant="h6" color="inherit">
          {defaultTitle}
        </Typography>
      </Toolbar>
      <Tabs value={tabsValue} centered aria-label="nav tabs example">
        {navigationLinks.map(link => (
          <TabLink key={link.uri} value={withPrefix(link.uri)} label={link.name} to={link.uri} />
        ))}
      </Tabs>
    </AppBar>
  )
}

export default withStyles(styles)(SiteHeader)
